import { Handle, Position, NodeProps } from "reactflow";

export function getMatchingTextClass(bgClass: string): string {
	const match = bgClass.match(/^bg-(.+)-(\d{3})$/);
	if (!match) return "text-black";

	const [_, color, shade] = match;
	const isLight = parseInt(shade) <= 300;

	return `text-${color}-${isLight ? "800" : "200"}`;
}

const CategoryNode: React.FC<NodeProps> = ({
	data,
	selected,
	id,
	isConnectable,
}) => {
	// const bg = data?.color || "#ddd";
	// const textColor = getContrastingTextColor(bg as string);
	// console.log({ data });
	const bgClass = data?.color ?? "bg-gray-200";
	const textClass = getMatchingTextClass(bgClass);

	if (data?.isLabel) {
		// Section label styling
		return (
			<div
				style={{
					padding: "10px",
					width: data?.orientation === "vertical" ? "40px" : "auto",
					height: data?.orientation === "vertical" ? "120px" : "auto",
					borderRadius: "4px",
					background: "#0D0C2B",
					color: "#fff",
					border: "1px solid #666",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					writingMode:
						data?.orientation === "vertical" ? "vertical-rl" : "horizontal-tb",
					textOrientation:
						data?.orientation === "vertical" ? "mixed" : "upright",
					transform:
						data?.orientation === "vertical" ? "rotate(180deg)" : "none",
				}}>
				<div style={{ fontWeight: "bold", fontSize: "12px" }}>
					{data?.label}
				</div>
			</div>
		);
	}

	// console.info({ data, bgClass, textClass });

	return (
		<div
			style={{
				// padding: "10px",
				// borderRadius: "4px",
				// background,
				border: data?.border,
				width: data?.boxType === "department" ? "150px" : "200px",
			}}
			title={data?.label}
			className={`text-center cursor-pointer font-bold ${
				data?.boxType === "department"
					? "py-3 text-lg px-2"
					: "py-5 text-xl px-4"
			} rounded-md ${
				data?.boxType === "collection" ? "bg-white" : bgClass
			} ${textClass} ${data?.opacity < 1 ? "opacity-30" : "opacity-100"} ${
				data?.border
					? ""
					: selected
					? "border-2 border-black"
					: "border border-gray-400"
			} relative select-none`}>
			<div className="hidden">
				<span className="text-pink-800"></span>
				<span className="text-blue-800"></span>
				<span className="text-yellow-800"></span>
				<span className="text-purple-800"></span>
				<span className="text-red-800"></span>
				<span className="text-orange-800"></span>
				<span className="text-green-800"></span>
				<span className="text-[#1E3A8A]"></span>
				<span className="text-[#B91C1C]"></span>
				<span className="text-[#CA8A04]"></span>
				<span className="text-[#7E22CE]"></span>
				<span className="text-[#15803D]"></span>
				<span className="text-[#C2410C]"></span>
				<span className="text-[#BE185D]"></span>
				<span className="text-[#0F172A]"></span>
				<span className="text-[#525252]"></span>
				<span className="text-[#DC2626]"></span>
				<span className="text-[#D97706]"></span>
				<span className="text-[#166534]"></span>
			</div>
			<div
				className={`font-semibold break-words whitespace-normal line-clamp-5 hover:line-clamp-none`}>
				{data?.label}
			</div>
			{data?.onInfoClick && (
				<>
					<button
						onClick={e => {
							e.stopPropagation(); // Prevent node drag/select on icon click
							data?.onInfoClick();
						}}
						className="absolute top-[-2px] right-[-2px] w-5 h-5 rounded-full bg-white bg-opacity-70 text-gray-800 flex items-center justify-center text-sm font-semibold cursor-pointer"
						title="More info"
						aria-label="More info"
						type="button">
						i
					</button>
				</>
			)}
			<Handle
				type="source"
				position={Position.Top}
				style={{ background: "#555" }}
				isConnectable={isConnectable}
			/>
			<Handle
				type="target"
				position={Position.Bottom}
				style={{ background: "#555" }}
				isConnectable={isConnectable}
			/>
		</div>
	);
};

export default CategoryNode;
